import React, { useState, useEffect } from "react";
import styled from "styled-components";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import SearchInput from "../SearchInput";

interface DropDownListProps {
    optionsLength: number;
}

const DropDownContainer = styled.div`
    display: grid;
    gap:8px;
    width:100%;
    // max-width: 50%;
`;

const InputFeild = styled.div`
    display: flex;
    padding: 8px 8px 8px 12px;
    align-items: center;
    gap: 4px;
    flex-shrink: 0;
    border-radius: 4px;
    border: 1px solid ${({ theme }) => theme.borderColor};
    background: ${({ theme }) => theme.playerContentBackground};
    
`;

const InputHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1 0 0;
    .arrow-icon {
        color: ${({ theme }) => theme.playerColor};
    }
`;

const InputTitle = styled.span`
    flex: 1 0 0;
    color: ${({ theme }) => theme.NumberColor};
    font-feature-settings: 'clig' off, 'liga' off;
    font-family: 'Aeonik';
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    cursor: pointer;
`;

const DropDownListContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 4px;
    padding: 4px 4px 8px 4px;
    border-radius: 4px;
    border: 1px solid ${({ theme }) => theme.secondaryButtonBorderColor};
    background: ${({ theme }) => theme.secondaryButtonBackground};
    box-shadow: ${({ theme }) => theme.boxShadow};
    position: absolute;
    top: 85px;
    z-index: 99;
    width: 100%;
`;

const DropDownList = styled.div<DropDownListProps>`
    overflow-y: ${({ optionsLength }) => (optionsLength > 10 ? 'scroll' : 'visible')};
    max-height: ${({ optionsLength }) => (optionsLength > 10 ? '300px' : 'auto')};
    width: 100%;
    scrollbar-color: ${({ theme }) => `${theme.NumberColor} ${theme.playerContentBackground}`};
`;

const ListItem = styled.div<{ isSelected: boolean }>`
    display: flex;
    height: 48px;
    padding: 0px 8px;
    gap: 8px;
    align-self: stretch;
    border-radius: 2px;
    background: ${({ theme, isSelected }) => isSelected ? theme.dropdownBorderColor : theme.secondaryButtonBackground};
    color: ${({ theme }) => theme.NumberColor};
    font-feature-settings: 'clig' off, 'liga' off;
    flex-direction: column;
    justify-content: center;
    font-family: 'Aeonik';
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px; 
    cursor: pointer;

    &:hover {
        border-radius: 2px;
        background: ${({ theme }) => theme.dropdownBorderColor};
    } 
`;


interface Option {
    label: string;
    value: string;
}
interface StandardDropdownProps {
    options: Option[];
    value?: string;
    onChange?: (value: string) => void;
    placeholder?: string;
    disabled?: boolean;
    onClick?: () => void; // Add onClick to the interface
    isDisplaySearchInput?: boolean;
    defaultSelected?: string;
    isForClub?: boolean
}

const StandardDropdown: React.FC<StandardDropdownProps> = ({ options, onChange, placeholder, disabled, isDisplaySearchInput = true , defaultSelected , isForClub }) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [selectedOption, setSelectedOption] = useState<string | null>(null);
    const [filteredOptions, setFilteredOptions] = useState(options);

    const toggling = (): void => setIsOpen(!isOpen);

    const onOptionClicked = (value: string) => (): void => {
        setSelectedOption(value);
        setIsOpen(false);
        if (onChange) onChange(value); // Call onChange if provided
    };

    useEffect(() => {
        // Reset filtered options to all options initially or when options change
        setFilteredOptions(options);
    }, [options]);

    const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        // Filter options based on search input value
        const filtered = options.filter((option) =>
            option.label.toLowerCase().includes(value.toLowerCase())
        );
        setFilteredOptions(filtered);
    };

    const handleClear = () => {
        setFilteredOptions(options);
    };

    return (
        <DropDownContainer>
            <InputFeild onClick={toggling}>
                <InputHeader>
                    <InputTitle>
                        {selectedOption ? options.find(option => option.value === selectedOption)?.label : defaultSelected}
                    </InputTitle>
                    {isOpen ? <KeyboardArrowUpIcon sx={{ fontSize: '24px' }} className="arrow-icon" /> :
                        <KeyboardArrowDownIcon sx={{ fontSize: '24px' }} className="arrow-icon" />}
                </InputHeader>
            </InputFeild>
            {isOpen && (
                <DropDownListContainer className="select-season-main" style={{top: isForClub ? '210px' : '85px'}}>
                    <DropDownList optionsLength={options.length}>
                        <ListItem isSelected={!selectedOption}>{placeholder}</ListItem>
                        {isDisplaySearchInput && <SearchInput handleSearch={handleSearch} handleClear={handleClear} />}
                        {filteredOptions.map((option, index) => (
                            <ListItem key={option.value} isSelected={selectedOption === option.value}
                                onClick={onOptionClicked(option.value)}>
                                {option.label}
                            </ListItem>
                        ))}
                    </DropDownList>
                </DropDownListContainer>
            )}
        </DropDownContainer>
    );
};

export default StandardDropdown;
